export default __webpack_public_path__ + "static/media/ohp.1729c9cf.svg";